import { InboundIframeMessage } from './types';
import { useAttachToIframe } from './useAttachToIframe';
import { useIframeMessenger } from './useIframeMessenger';

export type UsePreviewListenerArgs = {
  onMessage?: (message: InboundIframeMessage) => void;
};

// NOTE: This is limited to communicating with 1 iframe at a time, can support more in the future.
export const useIframeMessageBus = (args: UsePreviewListenerArgs) => {
  const { onMessage } = args;
  const { attachIframeRef, iframeRef, hasIframeInitialized } = useAttachToIframe();
  const { sendMessage } = useIframeMessenger({ iframeRef, hasIframeInitialized, onMessage });

  return {
    sendMessage,
    attachIframeRef,
  };
};
